import { FeeDisclaimers } from './api/types';

const StateClass = {
  VIEWING_SEATS: 'tn-syos--viewing-seats',
  FULL_SCREEN_ENABLED: 'tn-syos--full-screen-enabled',
  WITH_SEATS_SELECTED: 'tn-syos--seats-selected',
  LEGEND_DETAILS_VISIBLE: 'tn-syos--legend-details-visible',
};

export type SyosSelectionMode = 'standard' | 'flex';

interface SyosConfig {
  bestAvailableBasePath: string; // /events/detail/{prodSeasonNo}/{perfNo}
  isLegendExpandedByDefault: boolean;
  screenButtonShouldDisplayPriceTypeDescription: boolean;
  priceRangeIncludesAllPriceTypes: boolean;
  screenButtonShouldRenderPriceRange: boolean;
  legendShouldRenderPriceRange: boolean;
  legendShouldRenderPriceTypeList: boolean;
  priceTypeSortOrder: string;
  wheelchairSeatBadgeColor: string;
  specialSeatBadgeColor: string;
  isFeeDisclaimerVisible: boolean;
  isOrderLevelFeeDisclaimerDisplayed: boolean;
  orderLevelFeeDisclaimerText: string;
  feeDisclaimers: FeeDisclaimers;
  rootHeadingLevel: number;
  selectionMode: SyosSelectionMode;
  priceTypeQuantities: number[];
}

const defaultSyosConfig: SyosConfig = {
  bestAvailableBasePath: '',
  isLegendExpandedByDefault: false,
  screenButtonShouldDisplayPriceTypeDescription: false,
  priceRangeIncludesAllPriceTypes: true,
  screenButtonShouldRenderPriceRange: true,
  legendShouldRenderPriceRange: true,
  legendShouldRenderPriceTypeList: true,
  priceTypeSortOrder: 'PriceDescending',
  wheelchairSeatBadgeColor: '#000000',
  specialSeatBadgeColor: '#000000',
  isFeeDisclaimerVisible: true,
  isOrderLevelFeeDisclaimerDisplayed: false,
  orderLevelFeeDisclaimerText: '',
  feeDisclaimers: {},
  rootHeadingLevel: 3,
  selectionMode: 'standard',
  priceTypeQuantities: [],
};

export default SyosConfig;

export {
  defaultSyosConfig,
  StateClass,
};
